<template>
    <div class="comContent">
        <div class="expand-form">
            <div style="width: 100%; " class="flex-box">
                <searchForm v-model="searchData"  :labelList="searchLabelList" :formItems="searchLabelList" :expanded="false"
                    :isExpanded="false" :searchData="searchData" @reset="resetForm" :showExport="false" @search="getList(1)">
                </searchForm>

            </div>
        </div>

        <myTable :index="index" :selection="false" :page="page" :showpage="true" :operation="false" v-loading="loading"
            :table-data="tableData" :table-option.sync="tableOption" @page-change="getList" :expand="false">
            <template slot="status" slot-scope="scope">
                {{ scope.row.status | filtersStatus }}
            </template>
            <template slot="concatName" slot-scope="scope">
                {{ scope.row.concatName }}
                {{ scope.row.concatPhone }}
            </template>
            <template slot="operation" slot-scope="scope">
                <div style="margin: 0 0px">
                    <el-link type="primary" :underline="false" @click="checkDetails(scope.row, 'detail')"
                        style="margin-right: 10px">
                        查看
                    </el-link>
                </div>
            </template>

        </myTable>
    </div>
</template>
<script>
const activeOptions = [
    {
        name: "待审核",
        id: 0,
    },
    {
        name: "未通过",
        id: 1,
    },
    {
        name: "已通过",
        id: 2,
    },

];
import searchForm from "./component/searchForm.vue";
import myTable from "@/components/myTable";
import { queryActivityApplyList } from "@/api/platActivityManage";

export default {
    components: { searchForm, myTable },
    props: {},
    data() {
        return {
            expanded: false,
            isExpanded: false,
            loading: false,
            operation: true,
            selection: true,
            index: false,
            page: {
                total: 0,
                current: 1,
                size: 10,
                pageSizes: [10, 20, 30, 50],
            },
            tableData: [],
            tableOption: [
                { label: "活动名称", prop: "activityName", },
                { label: "店铺信息", prop: "shopName", },
                { label: "运营人员&联系方式", prop: "concatName", slot: true },
                { label: "在售商品数", prop: "onSale", },
                { label: "申请时间", prop: "createTime", },
                { label: "状态", prop: "status", slot: true },
                { label: "更新人", prop: "updateBy", },
                { label: "更新时间", prop: "updateTime", },
                { label: "操作", prop: "operation", slot: true },
            ],
            searchData: {
                name: "",
                shopType: "",
                payShopName: '',
            },
            expandedList: [

            ],
            searchLabelList: [
                {
                    name: "搜索活动名称",
                    fieldName: "activityName",
                    type: "input", 
                },
                {
                    name: "搜索店铺",
                    fieldName: "shopName",
                    type: "input", 
                },
                {
                    name: "筛选状态",
                    width: 150,
                    fieldName: "status",
                    type: "select",
                    disabled: false,
                    select: activeOptions, 
                },
                {
                    name: "筛选申请时间",
                    fieldName: "date",
                    type: "daterange", 
                    width: 250,
                    labelWidth: 100,
                },
            ],
        };
    },
    filters: {
        filtersStatus(e) {
            for (let i = 0; i < activeOptions.length; i++) {
                if (e == activeOptions[i].id) {
                    return activeOptions[i].name
                }
            }
        }
    },
    created() { },
    mounted() {
        this.getList();
    },
    methods: {
        getList(current) {
            if (this.searchData.date) {
                this.searchData.strTime = this.searchData.date[0];
                this.searchData.endTime = this.searchData.date[1];
            }
            const params = Object.assign({}, this.searchData);
            params.size = this.page.size;
            if (current) {
                this.page.current = current;
            }
            params.current = this.page.current;
            queryActivityApplyList(params).then((res) => {
                if (res) {
                    this.tableData = res.records;
                    this.page.total = res.total;
                } else {
                    this.tableData = [];
                    this.page.total = 0;
                }
            });
        },
        resetForm() {
            this.page.current = 1;
            for (const key in this.searchData) {
                this.searchData[key] = ""
            }
            this.getList(1)
        },
        // 查看详情
        checkDetails(row, type) {
            this.$router.push({
                path: './platActivityManage-activityAuditDetail',
                query: { applyId: row.id, orderId: row.orderId, shopId: row.shopId, activityName: row.activityName,status:row.status }
            })
        },
        handleExpand() {
            this.expanded = !this.expanded;
        }
    },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
    height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
    height: calc(100% - 118px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
    height: calc(100% - 78px) !important;
    overflow-y: scroll !important;
}

.expand-form {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
}

.flex-box {
    display: flex;
    justify-content: space-between;
}
</style>
  